import React from 'react'
import { Field } from 'react-final-form';
import { CampoForm } from './CampoForm'
import { useState } from 'react';

export function CampoSenha(props) {
    const required = value => (value ? undefined : "Campo obrigatório");
    const [esconder, setEsconder] = useState(props.esconder ?? true)
    var obj = { 
        iconesDir: [], 
        iconeDir: false, 
        ...props 
    }

    obj.iconesDir.push({
        icone: (esconder ? 'eye' : 'eye-slash'),
        onClick: () => setEsconder(!esconder), 
        titleIcone: (esconder ? 'Mostrar' : 'Esconder') + ' senha'
    })

    if (props.iconeDir) {
        obj.iconesDir.push({
            icone: 'lock',
        })
        obj.iconeDir = null;
    }

    // if (props.iconeEsq) {
    //     obj.iconeEsq = 'lock';
    // }

    return (
        <Field name={props.nome} validate={((props.obrigatorio) ? required : undefined)}>
            {({ input, meta }) => {
                return (
                    <CampoForm {...obj} meta={meta}>
                        <input {...input}
                            id={props.id}
                            className={`form-control${((!props.tamanhoNormal) && (!props.tamanhoGrande) ? ' form-control-sm' : '')}${(((meta.error) && (meta.touched)) ? ' is-invalid' : '')}`}
                            type={esconder ? "password" : "text"}
                            autoComplete={!props.lembrar ? "new-password" : null}
                            placeholder={props.placeholder} readOnly={props.readOnly} />
                        {props.children}
                    </CampoForm>
                )
            }}
        </Field>
    )
}